import Vue from 'vue';

const success = (context, response) => {
  toastr.success(response.msg);
  context.loading = false;
  Vue.router.push({
    name: 'rentals.index',
  });
};

const failed = (context, error) => {
  if (error && error.response && error.response.data && error.response.data.subscription_is_not_active) {
    context.openModal('#add-card-modal');
  } else {
    context.showToasterError(error);
  }
  context.loading = false;
};

export default (context, rental) => {
  return Vue.$http.post('/rentals', rental).then(response => {
    if (response && response.status === 200) {
      success(context, response.data);
    }
  }).catch(error => {
    failed(context, error);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/storeRental.js